import PrimaryCell from "../../../../../../../ui/Table/Cells/PrimaryCell";
import ButtonsCell from "../../../../../../../ui/Table/Cells/ButtonsCell";

export const columns = [
  {
    dataField: "criterion",
    caption: "Критерий",
    dataType: "string",
    cellRender: PrimaryCell,
    width: "60%"
  },
  {
    dataField: "result",
    caption: "Оценка",
    dataType: "string",
    cellRender: PrimaryCell
  },

  {
    type: "buttons",
    cellRender: ButtonsCell,
    width: 110
  }
];
